export default class BulkUploadError extends Error {
  public constructor(title: string, public readonly errors: string[]) {
    super(title);
  }
}
